import { Policies } from "@fena/toolkit-types";
import { useQuery } from "@tanstack/react-query";
import Api from "../../../../../../util/api";
import { ExternalAppApiType, QueryKeys } from "../../../../../../util/types";
import { useQueryErrorHandler } from "../../../../../../util/data-utils";
import { usePolicyCheck } from "../../../../hooks/usePolicyCheck";

export const useGetExternalAppList = () => {
  const { checkAccessByPolicies } = usePolicyCheck();

  const canRequest = checkAccessByPolicies(
    [Policies.APPS.ADMIN_ACCESS],
    [Policies.APPS.VIEW_APPS]
  );

  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch: refreshApps,
  } = useQuery<ExternalAppApiType[], any>({
    queryKey: [QueryKeys.LIST_EXTERNAL_APP],
    enabled: canRequest,
    queryFn: async () => await Api.getExternalAppList(),
    placeholderData: (prev) => prev ?? [],
  });

  useQueryErrorHandler({
    isError,
    errorMessage: error?.error?.message ?? "Failed to fetch external apps",
    handlerId: QueryKeys.LIST_EXTERNAL_APP,
  });

  return {
    data: data ?? [],
    loading: isLoading || isFetching,
    refreshApps,
  };
};
